import { useQuery } from "@tanstack/react-query";
import { api } from "../utils/hostname";
import { LoyaltyBFF } from "../types/LoyaltyBFF";
import url from "../url";

export const useGetUserProgressLoyalty = () => {
  return useQuery<unknown, unknown, LoyaltyBFF, ["user progress loyalty"]>({
    queryKey: ["user progress loyalty"],
    queryFn: async () => {
      const response = await api(true, true).get<LoyaltyBFF>(
        url.config.api.loyalty.allUserProgress,
      );

      return response.data;
    },
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
